import React from 'react'
import {motion} from 'framer-motion'
import PropTypes from 'prop-types'

export function FlipAnimation({front, back, isFlipped}) {
    return (
        <motion.div
            style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                transformStyle: 'preserve-3d',
                willChange: 'transform'
            }}
            animate={{rotateY: isFlipped ? 180 : 0}}
            transition={{duration: 0.8, ease: [0.22, 1, 0.36, 1]}}
        >
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backfaceVisibility: 'hidden'
                }}
            >
                {front}
            </div>

            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backfaceVisibility: 'hidden',
                    transform: 'rotateY(180deg)'
                }}
            >
                {back}
            </div>
        </motion.div>
    )
}

FlipAnimation.propTypes = {
    front: PropTypes.shape(),
    back: PropTypes.shape(),
    isFlipped: PropTypes.bool
}
